import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

// Import images
import breadcrumbBg from '../../assets/img/bg/breadcrumb-bg.png';
import cloudIcon from '../../assets/img/icons/cloud.png';
import ballonIcon from '../../assets/img/icons/ballon-sclation.png';
import koreaImg from '../../assets/img/korea.png';
import keralaImg from '../../assets/img/kerala.jpg';
import seoulImg from '../../assets/img/SEOUL.png';
import maduraiImg from '../../assets/img/MADHURAI.png';
import jejuImg from '../../assets/img/JEJU.png';
import karnatakaImg from '../../assets/img/kRNtK.png';
import busanImg from '../../assets/img/BUSAN.png';

const BookDestination = () => {
    useEffect(() => {
        // Set minimum date for departure date
        const today = new Date();
        today.setDate(today.getDate() + 7);
        const minDate = today.toISOString().split("T")[0];
        const departureInput = document.getElementById("departure");
        if (departureInput) {
            departureInput.min = minDate;
        }
    }, []);

    const scrollToBooking = () => {
        const bookingSection = document.getElementById("booking");
        if (bookingSection) {
            bookingSection.scrollIntoView({
                behavior: "smooth",
            });
        }
    };

    const scrollToTop = (e) => {
        e.preventDefault();
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    const similarTours = [
        {
            id: 1,
            image: keralaImg,
            location: "Kerala, South India",
            title: "Kerala Backwaters & Ayurvedic Retreat",
            duration: "7 Days",
            originalPrice: "₹62,000",
            discountedPrice: "₹45,000"
        },
        {
            id: 2,
            image: seoulImg,
            location: "Seoul, South Korea",
            title: "Seoul K-Pop & Palace Discovery Tour",
            duration: "5 Days",
            originalPrice: "₹85,000",
            discountedPrice: "₹68,000"
        },
        {
            id: 3,
            image: maduraiImg,
            location: "Tamil Nadu, India",
            title: "Tamil Nadu Temple & Cultural Trail",
            duration: "6 Days",
            originalPrice: "₹52,000",
            discountedPrice: "₹38,000"
        },
        {
            id: 4,
            image: jejuImg,
            location: "Jeju Island, Korea",
            title: "Jeju Island Natural Wonders Escape",
            duration: "4 Days",
            originalPrice: "₹48,000",
            discountedPrice: "₹35,000"
        },
        {
            id: 5,
            image: karnatakaImg,
            location: "Karnataka, India",
            title: "Karnataka Heritage & Coffee Plantations",
            duration: "5 Days",
            originalPrice: "₹42,000",
            discountedPrice: "₹32,000"
        },
        {
            id: 6,
            image: busanImg,
            location: "Busan, South Korea",
            title: "Busan Coastal City & Seafood Delights",
            duration: "4 Days",
            originalPrice: "₹55,000",
            discountedPrice: "₹42,000"
        }
    ];

    return (
        <div className="book-destination-page">
            {/* Breadcrumb Section */}
            <section
                className="vs-breadcrumb"
                style={{
                    backgroundImage: `url(${breadcrumbBg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    position: 'relative',
                    overflow: 'hidden',
                    padding: '100px 0'
                }}
            >
                <img
                    src={cloudIcon}
                    alt="vs-breadcrumb-icon"
                    className="vs-breadcrumb-icon-1"
                    style={{
                        position: 'absolute',
                        top: '20%',
                        left: '10%',
                        zIndex: 1,
                        animation: 'float 6s ease-in-out infinite'
                    }}
                />
                <img
                    src={ballonIcon}
                    alt="vs-breadcrumb-icon"
                    className="vs-breadcrumb-icon-2"
                    style={{
                        position: 'absolute',
                        bottom: '20%',
                        right: '10%',
                        zIndex: 1,
                        animation: 'float 6s ease-in-out infinite'
                    }}
                />
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title" style={{
                                    color: '#fff',
                                    fontSize: '48px',
                                    fontWeight: '700',
                                    marginBottom: '20px',
                                    textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
                                }}>
                                    South India & Korea Cultural Fusion
                                </h1>
                            </div>
                            <div className="breadcrumb-menu">
                                <ul className="custom-ul" style={{
                                    listStyle: 'none',
                                    padding: 0,
                                    margin: 0,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: '10px',
                                    color: '#fff'
                                }}>
                                    <li>
                                        <Link
                                            to="/"
                                            style={{
                                                color: '#fff',
                                                textDecoration: 'none',
                                                transition: 'color 0.3s ease'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.target.style.color = '#f7921f';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.target.style.color = '#fff';
                                            }}
                                        >
                                            Home
                                        </Link>
                                    </li>
                                    <li style={{ color: '#f7921f' }}>→</li>
                                    <li style={{ color: '#f7921f' }}>Trips details</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Destination Details Section */}
            <section className="vs-destination-details space bg-theme-07">
                <div className="container">
                    <div className="row gx-3 gx-xl-5 gy-5">
                        <div className="col-lg-8">
                            <div className="vs-destination-single">
                                <div className="row align-items-center gy-3 mb-4">
                                    <div className="col-8 col-sm-10">
                                        <h2 className="destination-single-title">
                                            South India & Korea Cultural Fusion
                                        </h2>
                                        <div className="rating-badge">
                                            <span className="stars">★★★★★</span>
                                            <span className="review-count">(128 Reviews)</span>
                                        </div>
                                    </div>
                                    <div className="col-4 col-sm-2 d-flex justify-content-end">
                                        <div className="destination-single-meta">
                                            <h3>10</h3>
                                            <span>days</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="destination-single-info">
                                    <figure className="destination-single-img d-block" style={{ position: 'relative' }}>
                                        <img
                                            src={koreaImg}
                                            alt="South India Korea Cultural Tour"
                                            style={{ width: '100%', borderRadius: '15px' }}
                                        />
                                        <div className="image-badge">
                                            <span className="trending-badge">🔥 Trending</span>
                                            <span className="family-badge">👨‍👩‍👧‍👦 Family Friendly</span>
                                        </div>
                                    </figure>
                                    <div className="destination-single-px">
                                        <div className="trip-info">
                                            <div className="trip-info-box">
                                                <div className="header">
                                                    <i className="fa-solid fa-plane"></i>
                                                    <span>Transportation</span>
                                                </div>
                                                <h6 className="info-title">Flight, AC Coach, Metro</h6>
                                            </div>
                                            <div className="trip-info-box">
                                                <div className="header">
                                                    <i className="fa-solid fa-location-dot"></i>
                                                    <span>Departure From</span>
                                                </div>
                                                <h6 className="info-title">Delhi, Mumbai, Bangalore</h6>
                                            </div>
                                            <div className="trip-info-box">
                                                <div className="header">
                                                    <i className="fa-solid fa-users"></i>
                                                    <span>Group Size</span>
                                                </div>
                                                <h6 className="info-title">2-20 Travelers</h6>
                                            </div>
                                            <div className="trip-info-box">
                                                <div className="header">
                                                    <i className="fa-solid fa-hotel"></i>
                                                    <span>Accommodation</span>
                                                </div>
                                                <h6 className="info-title">
                                                    4 Star Hotels & Traditional Stays
                                                </h6>
                                            </div>
                                            <div className="trip-info-box">
                                                <div className="header">
                                                    <i className="fa-solid fa-calendar"></i>
                                                    <span>Best Season</span>
                                                </div>
                                                <h6 className="info-title">Oct - Mar (Pleasant Weather)</h6>
                                            </div>
                                            <div className="trip-info-box">
                                                <div className="header">
                                                    <i className="fa-solid fa-user"></i>
                                                    <span>Minimum Age</span>
                                                </div>
                                                <h6 className="info-title">8 Years</h6>
                                            </div>
                                            <div className="trip-info-box">
                                                <div className="header">
                                                    <i className="fa-solid fa-utensils"></i>
                                                    <span>Meals</span>
                                                </div>
                                                <h6 className="info-title">Breakfast & Special Dinners</h6>
                                            </div>
                                            <div className="trip-info-box">
                                                <div className="header">
                                                    <i className="fa-solid fa-camera"></i>
                                                    <span>Tour Type</span>
                                                </div>
                                                <h6 className="info-title">Cultural, Food, Photography</h6>
                                            </div>
                                        </div>

                                        {/* Overview Section */}
                                        <div id="current" className="destination-overview tab-content">
                                            <h4 className="title">Tour Overview</h4>
                                            <p>
                                                Embark on an extraordinary journey that blends the rich
                                                cultural heritage of South India with the modern wonders
                                                of Korea. This carefully curated 10-day experience takes
                                                you from the serene backwaters of Kerala to the vibrant
                                                streets of Seoul, creating memories that will last a
                                                lifetime.
                                            </p>
                                            <p>
                                                Experience the perfect harmony of ancient traditions and
                                                cutting-edge technology as you explore temple towns,
                                                palace complexes, K-pop culture, and culinary delights
                                                across two fascinating destinations.
                                            </p>

                                            <div className="highlights-section">
                                                <h5>🌟 Tour Highlights</h5>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <ul className="custom-ul">
                                                            <li>
                                                                <i className="fa-solid fa-house-water"></i>
                                                                Stay in traditional Kerala houseboat
                                                            </li>
                                                            <li>
                                                                <i className="fa-solid fa-crown"></i>
                                                                Visit Gyeongbokgung Palace in Seoul
                                                            </li>
                                                            <li>
                                                                <i className="fa-solid fa-utensils"></i>
                                                                Authentic Korean BBQ cooking class
                                                            </li>
                                                            <li>
                                                                <i className="fa-solid fa-spa"></i>
                                                                Ayurvedic massage experience in Kerala
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <ul className="custom-ul">
                                                            <li>
                                                                <i className="fa-solid fa-camera"></i>
                                                                K-pop street and entertainment districts
                                                            </li>
                                                            <li>
                                                                <i className="fa-solid fa-mountain"></i>
                                                                Tea plantation tour in Munnar hills
                                                            </li>
                                                            <li>
                                                                <i className="fa-solid fa-ship"></i>
                                                                Jeju Island volcanic landscape exploration
                                                            </li>
                                                            <li>
                                                                <i className="fa-solid fa-gem"></i>
                                                                Traditional Kathakali dance performance
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Booking Form Section */}
                                        <div id="booking" className="destination-request tab-content">
                                            <h4 className="title">Book This Tour</h4>
                                            <h5 className="sub-title">
                                                Ready for your adventure? Fill the form below and we'll
                                                contact you within 24 hours.
                                            </h5>
                                            <p className="short-info">
                                                <strong>Tour Package:</strong> South India & Korea
                                                Cultural Fusion (10 Days)
                                            </p>
                                            <div className="row">
                                                <div className="col-12">
                                                    <form action="#" method="post" className="form-style2">
                                                        <div className="row">
                                                            <div className="col-md-6 form-group">
                                                                <label htmlFor="name">
                                                                    Your Name <span>*</span>
                                                                </label>
                                                                <input
                                                                    id="name"
                                                                    name="name"
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter Your Full Name"
                                                                    required
                                                                />
                                                            </div>
                                                            <div className="col-md-6 form-group">
                                                                <label htmlFor="email">
                                                                    Your Email <span>*</span>
                                                                </label>
                                                                <input
                                                                    id="email"
                                                                    name="email"
                                                                    type="email"
                                                                    className="form-control"
                                                                    placeholder="Enter Your Email"
                                                                    required
                                                                />
                                                            </div>
                                                            <div className="col-md-6 form-group">
                                                                <label htmlFor="phone">
                                                                    Contact Number <span>*</span>
                                                                </label>
                                                                <input
                                                                    id="phone"
                                                                    name="phone"
                                                                    type="tel"
                                                                    className="form-control"
                                                                    placeholder="Enter Your Mobile Number"
                                                                    required
                                                                />
                                                            </div>
                                                            <div className="col-md-6 form-group">
                                                                <label htmlFor="departure">
                                                                    Preferred Departure Date
                                                                </label>
                                                                <input
                                                                    id="departure"
                                                                    name="departure"
                                                                    type="date"
                                                                    className="form-control"
                                                                />
                                                            </div>
                                                            <div className="col-md-6 form-group">
                                                                <label htmlFor="adults">Number of Adults</label>
                                                                <select
                                                                    id="adults"
                                                                    name="adults"
                                                                    className="form-control"
                                                                >
                                                                    <option value="1">1 Adult</option>
                                                                    <option value="2" defaultValue>2 Adults</option>
                                                                    <option value="3">3 Adults</option>
                                                                    <option value="4">4 Adults</option>
                                                                    <option value="5+">5+ Adults</option>
                                                                </select>
                                                            </div>
                                                            <div className="col-md-6 form-group">
                                                                <label htmlFor="children">Number of Children</label>
                                                                <select
                                                                    id="children"
                                                                    name="children"
                                                                    className="form-control"
                                                                >
                                                                    <option value="0" defaultValue>
                                                                        No Children
                                                                    </option>
                                                                    <option value="1">1 Child</option>
                                                                    <option value="2">2 Children</option>
                                                                    <option value="3">3 Children</option>
                                                                </select>
                                                            </div>
                                                            <div className="col-12 form-group">
                                                                <label htmlFor="message">
                                                                    Special Requirements
                                                                </label>
                                                                <textarea
                                                                    id="message"
                                                                    name="message"
                                                                    className="form-control"
                                                                    placeholder="Any dietary restrictions, special occasions, or specific requirements..."
                                                                ></textarea>
                                                            </div>
                                                            <div className="col-12 form-group mb-0">
                                                                <button
                                                                    className="vs-btn style9 w-100"
                                                                    type="submit"
                                                                >
                                                                    <i className="fa-solid fa-paper-plane me-2"></i>
                                                                    Send Booking Request
                                                                </button>
                                                                <p className="text-center mt-3">
                                                                    <small>
                                                                        🔒 Your information is secure and will
                                                                        never be shared with third parties
                                                                    </small>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Sidebar */}
                        <div className="col-lg-4">
                            <div className="sidebar-area tours-sidebar">
                                <div
                                    className="widget widget_trip-Availability accordion"
                                    id="accordionTripAvailability"
                                >
                                    <div className="accordion-item">
                                        <h6 className="accordion-header">
                                            <button
                                                className="accordion-button"
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target="#collapseOne_1"
                                                aria-expanded="true"
                                            >
                                                💰 Package Pricing
                                            </button>
                                        </h6>
                                        <div
                                            id="collapseOne_1"
                                            className="accordion-collapse collapse show"
                                        >
                                            <div className="accordion-body">
                                                <div className="header">
                                                    <span className="offer">Limited Time Offer</span>
                                                    <div
                                                        className="package-wrapper d-flex justify-content-between gap-2"
                                                    >
                                                        <div className="adult-price">
                                                            <div className="title">
                                                                from
                                                                <del>₹1,35,000</del>
                                                            </div>
                                                            <h5 className="price">
                                                                ₹95,000
                                                                <span>/Adult</span>
                                                            </h5>
                                                        </div>
                                                        <div className="child-price">
                                                            <div className="title">
                                                                from
                                                                <del>₹1,10,000</del>
                                                            </div>
                                                            <h5 className="price">
                                                                ₹75,000
                                                                <span>/Child</span>
                                                            </h5>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="body">
                                                    <ul className="custom-ul">
                                                        <li>
                                                            <i className="fa-solid fa-badge-check"></i> Best Price
                                                            Guaranteed
                                                        </li>
                                                        <li>
                                                            <i className="fa-solid fa-badge-check"></i> No Hidden
                                                            Charges
                                                        </li>
                                                        <li>
                                                            <i className="fa-solid fa-badge-check"></i> Flexible
                                                            Payment Options
                                                        </li>
                                                        <li>
                                                            <i className="fa-solid fa-badge-check"></i> Free
                                                            Cancellation*
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="footer">
                                                    <button
                                                        className="vs-btn style9 w-100"
                                                        onClick={scrollToBooking}
                                                    >
                                                        📅 Check Availability & Book
                                                    </button>
                                                    <p className="text-center mt-2">
                                                        Need help? <Link to="/contact">Chat with us</Link>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="widget widget_quick_contact">
                                    <h5 className="widget-title">📞 Quick Contact</h5>
                                    <div className="contact-info">
                                        <div className="contact-item">
                                            <i className="fa-solid fa-phone"></i>
                                            <div>
                                                <span>Call us 24/7:</span>
                                                <a href="tel:83174 47895" style={{
                                                    color: '#f7921f',
                                                    textDecoration: 'none',
                                                    display: 'block',
                                                    fontSize: '16px',
                                                    fontWeight: '500',
                                                    transition: 'color 0.3s ease'
                                                }}
                                                    onMouseEnter={(e) => e.target.style.color = '#f7921f'}
                                                    onMouseLeave={(e) => e.target.style.color = '#f7921f'}>
                                                    83174 47895
                                                </a>
                                            </div>
                                        </div>
                                        <div className="contact-item">
                                            <i className="fa-solid fa-whatsapp"></i>
                                            <div>
                                                <span>WhatsApp: </span>
                                                <a href="tel:83174 47895" style={{
                                                    color: '#f7921f',
                                                    textDecoration: 'none',
                                                    display: 'block',
                                                    fontSize: '16px',
                                                    fontWeight: '500',
                                                    transition: 'color 0.3s ease'
                                                }}
                                                    onMouseEnter={(e) => e.target.style.color = '#f7921f'}
                                                    onMouseLeave={(e) => e.target.style.color = '#f7921f'}>83174 47895</a>
                                            </div>
                                        </div>
                                        <div className="contact-item">
                                            <i className="fa-solid fa-envelope"></i>
                                            <div>
                                                <span>Email: </span>
                                                <a href="mailto:info@ascendtravel.com" style={{
                                                    color: '#f7921f',
                                                    textDecoration: 'none',
                                                    display: 'block',
                                                    fontSize: '16px',
                                                    fontWeight: '500',
                                                    transition: 'color 0.3s ease'
                                                }}
                                                    onMouseEnter={(e) => e.target.style.color = '#f7921f'}
                                                    onMouseLeave={(e) => e.target.style.color = '#f7921f'}>
                                                    Booking@ascendtravelsolutions.in</a
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="widget widget_why_choose">
                                    <h5 className="widget-title">⭐ Why Choose This Tour?</h5>
                                    <ul className="custom-ul">
                                        <li>
                                            <i className="fa-solid fa-check"></i> Perfect blend of culture
                                            & modernity
                                        </li>
                                        <li>
                                            <i className="fa-solid fa-check"></i> Handpicked experiences
                                        </li>
                                        <li>
                                            <i className="fa-solid fa-check"></i> Local expert guides
                                        </li>
                                        <li><i className="fa-solid fa-check"></i> Small group size</li>
                                        <li>
                                            <i className="fa-solid fa-check"></i> Best value for money
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Similar Tours Section */}
            <section className="vs-tour-package style-3 space-bottom bg-theme-07">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-auto mx-auto">
                            <div className="title-area text-center">
                                <span className="sec-subtitle text-capitalize"
                                >You Might Also Like</span
                                >
                                <h2 className="sec-title">Similar Travel Experiences</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row g-4">
                        {similarTours.map((tour) => (
                            <div key={tour.id} className="col-md-6 col-xl-4">
                                <div className="tour-package-box style-3 bg-white-color">
                                    <div className="tour-package-thumb">
                                        <img
                                            src={tour.image}
                                            alt={tour.title}
                                            className="w-100"
                                            style={{ height: '250px', objectFit: 'cover' }}
                                        />
                                    </div>
                                    <div className="tour-package-content">
                                        <div className="location">
                                            <i className="fa-sharp fa-light fa-location-dot"></i>
                                            <span>{tour.location}</span>
                                        </div>
                                        <h5 className="title line-clamp-2">
                                            <Link to="/bookdestination">{tour.title}</Link>
                                        </h5>
                                        <div className="tour-package-footer">
                                            <div className="tour-duration">
                                                <i className="fa-regular fa-clock"></i>
                                                <span>{tour.duration}</span>
                                            </div>
                                            <div className="pricing-info fw-medium">
                                                From
                                                <del className="text-theme-color fw-semibold">{tour.originalPrice}</del>
                                                <h5 className="new-price">{tour.discountedPrice}</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <button
                className="scrollToTop scroll-btn"
                onClick={scrollToTop}
                style={{
                    position: 'fixed',
                    bottom: '30px',
                    right: '30px',
                    width: '50px',
                    height: '50px',
                    backgroundColor: '#f7921f',
                    color: '#fff',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textDecoration: 'none',
                    fontSize: '20px',
                    transition: 'all 0.3s ease',
                    zIndex: 1000,
                    border: 'none',
                    cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#e6831a';
                    e.target.style.transform = 'translateY(-3px)';
                }}
                onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#f7921f';
                    e.target.style.transform = 'translateY(0)';
                }}
            >
                <i className="far fa-arrow-up"></i>
            </button>

            {/* Add CSS animations */}
            <style>{`
                @keyframes float {
                    0% { transform: translateY(0px); }
                    50% { transform: translateY(-20px); }
                    100% { transform: translateY(0px); }
                }
                
                @keyframes fadeInUp {
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                
                .vs-breadcrumb-icon-1,
                .vs-breadcrumb-icon-2 {
                    animation: float 6s ease-in-out infinite;
                }

                .rating-badge {
                    margin-top: 10px;
                }

                .stars {
                    color: #ffd700;
                    margin-right: 5px;
                }

                .review-count {
                    color: #666;
                    font-size: 14px;
                }

                .image-badge {
                    position: absolute;
                    top: 15px;
                    left: 15px;
                    display: flex;
                    flex-direction: column;
                    gap: 5px;
                }

                .trending-badge,
                .family-badge {
                    background: rgba(255, 255, 255, 0.95);
                    padding: 5px 10px;
                    border-radius: 20px;
                    font-size: 12px;
                    font-weight: 600;
                    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
                }

                .trending-badge {
                    background: linear-gradient(135deg, #ff6b6b, #ff8e53);
                    color: white;
                }

                .highlights-section {
                    background: #f8f9fa;
                    padding: 20px;
                    border-radius: 10px;
                    margin: 20px 0;
                }

                .highlights-section h5 {
                    color: #2c3e50;
                    margin-bottom: 15px;
                }

                .contact-info {
                    display: flex;
                    flex-direction: column;
                    gap: 15px;
                }

                .contact-item {
                    display: flex;
                    align-items: center;
                    gap: 15px;
                    padding: 10px;
                    background: #f8f9fa;
                    border-radius: 8px;
                }

                .contact-item i {
                    width: 30px;
                    height: 30px;
                    background: #3498db;
                    color: white;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .widget_why_choose .custom-ul li {
                    margin-bottom: 8px;
                    padding: 8px 0;
                    border-bottom: 1px solid #eee;
                }

                .widget_why_choose .custom-ul li:last-child {
                    border-bottom: none;
                }
            `}</style>
        </div>
    );
};

export default BookDestination;